import { render, staticRenderFns } from "./continue-buy-button-group.vue?vue&type=template&id=8e3a6120"
import script from "./continue-buy-button-group.vue?vue&type=script&lang=js"
export * from "./continue-buy-button-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports